import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 3.5,
  stroke: "#fff"
});

var SvgZero = function SvgZero(props) {
  return React.createElement("svg", _extends({
    width: 8,
    height: 8
  }, props), _ref);
};

export default SvgZero;